import { render, staticRenderFns } from "./MobileOffers.vue?vue&type=template&id=fb92c95a&scoped=true&"
import script from "./MobileOffers.vue?vue&type=script&lang=js&"
export * from "./MobileOffers.vue?vue&type=script&lang=js&"
import style0 from "./MobileOffers.vue?vue&type=style&index=0&id=fb92c95a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb92c95a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb92c95a')) {
      api.createRecord('fb92c95a', component.options)
    } else {
      api.reload('fb92c95a', component.options)
    }
    module.hot.accept("./MobileOffers.vue?vue&type=template&id=fb92c95a&scoped=true&", function () {
      api.rerender('fb92c95a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/orange/broadband/demands/showcase/internetandmobileoffers/components/MobileOffers.vue"
export default component.exports